import React, { useMemo, useCallback } from 'react';
import {
  TablePaginatedUC,
  CellLeft,
  CellDateTime,
  CellIntCustom,
  EyeColumn,
  CellCenter,
} from 'motion-components';
import { useLocation } from 'react-router-dom';
import { generatePath, useHistory } from 'react-router';

import LoadingOverlay from '@achmadk/react-loading-overlay';
import { useRootStore } from 'store';
import { getRouteByName } from 'app/routes';
import { useTranslation } from 'react-i18next';

/* ----------- Grid ------------------ */

export const DataGrid = ({
  data,
  dataCount,
  initPageIndex,
  onPageChange,
  loading,
  handleExport,
}) => {
  const { t } = useTranslation();

  const location = useLocation<any>();
  const history = useHistory();
  const { appStore } = useRootStore();

  const rowClicked = useCallback(
    (row) => {
      history.push({
        pathname: generatePath(getRouteByName('Log'), { id: row.id }),
        state: {
          pathname: location.pathname,
          ...location.state,
        },
      });
    },
    [history, location.pathname, location.state],
  );

  const columns = useMemo(
    () => [
      // { Header: "id", accessor: "id", Cell: CellCenter, width: "100", isVisible: false, },
      EyeColumn(rowClicked),
      {
        Header: 'ID',
        accessor: 'id',
        Cell: CellCenter,
        width: '100',
        isVisible: false,
      },
      {
        Header: t('Date'),
        accessor: 'logDate',
        Cell: CellDateTime,
        width: '100',
        isVisible: false,
      },
      {
        Header: t('Event Type'),
        accessor: 'logType',
        Cell: CellLeft,
        width: '100',
        isVisible: false,
      },
      {
        Header: t('Event Source'),
        accessor: 'originatedFrom',
        Cell: CellLeft,
        width: '100',
        isVisible: false,
      },
      {
        Header: t('Grouping'),
        accessor: 'grouping',
        Cell: CellLeft,
        width: '100',
        isVisible: false,
      },
      {
        Header: t('Message'),
        accessor: 'message',
        Cell: CellLeft,
        width: '100',
        isVisible: false,
      },
      {
        Header: t('User'),
        accessor: 'user',
        Cell: CellLeft,
        width: '100',
        isVisible: false,
      },
      {
        Header: t('Ip Address'),
        accessor: 'clientIp',
        Cell: CellLeft,
        width: '100',
        isVisible: false,
      },
    ],
    [rowClicked, t],
  );

  return (
    // <RingLoader loading={loading}>
    <LoadingOverlay active={loading} spinner text={t('Please wait...')}>
      {data ? (
        <TablePaginatedUC
          id="grid"
          appStore={appStore}
          key="grid"
          title={'Λίστα'}
          columns={columns}
          data={data}
          dataCount={dataCount}
          // initPageIndex={initPage}
          // onSortByChange={handleSortByChange}
          onExport={handleExport}
          onPageChange={onPageChange}
          initPageIndex={initPageIndex}
          resizable={true}
        />
      ) : (
        <div style={{ height: '200px' }}></div>
      )}
    </LoadingOverlay>
    // </RingLoader>
  );
};
